const PRIMARY_NAME = ['A', 'N', 'H', 'L', 'Q', '9', '8'];
const INFO_NAME = ['F', 'G', 'T', 'I', 'J', '1', '2', '3'];
const SUCCESS_NAME = ['K', 'D', 'Y', 'B', 'O', '4', '5'];
const WARNING_NAME = ['P', 'E', 'R', 'S', 'C', 'U', '6', '7'];
const ERROR_NAME = ['V', 'W', 'X', 'M', 'Z'];

export const getInitials = (name: string) => {
  const words = name.split(' ');
  return `${words[0].charAt(0)} ${words[1].charAt(0)}`.toUpperCase();
};

const getAvatarColor = (name: string) => {
  if (PRIMARY_NAME.includes(getFirstCharacter(name))) return 'primary';
  if (INFO_NAME.includes(getFirstCharacter(name))) return 'info';
  if (SUCCESS_NAME.includes(getFirstCharacter(name))) return 'success';
  if (WARNING_NAME.includes(getFirstCharacter(name))) return 'warning';
  if (ERROR_NAME.includes(getFirstCharacter(name))) return 'error';
  return 'default';
};

const getFirstCharacter = (name: string) => getInitials(name).charAt(0);

export default function createAvatar(name: string) {
  return {
    name: getInitials(name),
    color: getAvatarColor(name),
  } as const;
}
